import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// One-time self-heal for the PostHog removal: browsers that visited while PostHog
// was live can retain a ph_* cookie and a cached PostHog-era service worker that
// still fires calls to an undefined host. Clear both once per browser, then the
// clean service worker re-registers below.
const PH_CLEANUP_FLAG = 'stilos_ph_cleanup_v1';
if (!localStorage.getItem(PH_CLEANUP_FLAG)) {
  try {
    document.cookie.split(';').forEach((c) => {
      const name = c.split('=')[0].trim();
      if (name.startsWith('ph_')) {
        ['/', ''].forEach((p) => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}`;
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}; domain=.stilos.my`;
        });
      }
    });
  } catch (e) { /* cookie access can throw in some privacy modes */ }
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
  try { localStorage.setItem(PH_CLEANUP_FLAG, '1'); } catch (e) { /* ignore */ }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
